import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PDFLoadingImageBackground = ({
  imagePlaceholders,
  pageIndex,
  children
}) => {
  if (pageIndex >= imagePlaceholders.length) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    position: "relative",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
        backgroundImage: `url(${imagePlaceholders[pageIndex]})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        filter: 'blur(5px)',
        zIndex: 1
      }
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2
      },
      children: /*#__PURE__*/_jsx(Flex, {
        inlineSize: "100%",
        blockSize: "100%",
        alignItems: "center",
        justifyContent: "center",
        children: children
      })
    })]
  });
};
PDFLoadingImageBackground.propTypes = {
  imagePlaceholders: PropTypes.array.isRequired,
  pageIndex: PropTypes.number.isRequired,
  children: PropTypes.any
};
export default PDFLoadingImageBackground;